import {
  JustifyContent,
  Box,
  AlignItems,
  ColorPreset,
  Space,
  ReadingOptimized,
  H2,
  TypePreset,
  P,
  ResponsiveValue,
  SpaceScale,
} from "@gocardless/flux-react";

interface PasswordResetCardWrapperProps {
  banner?: React.ReactElement;
  title: React.ReactElement;
  description: React.ReactElement;
  image: React.ReactElement;
  buttons: React.ReactElement;
  gutterV?: ResponsiveValue<SpaceScale>;
}

export const PasswordResetCardLayout = ({
  banner,
  title,
  description,
  image,
  buttons,
  gutterV = [4],
}: PasswordResetCardWrapperProps) => (
  <Box
    layout="flex"
    flexDirection="column"
    justifyContent={JustifyContent.Center}
    alignItems={AlignItems.Center}
    width="100%"
    height="100%"
  >
    <Box
      layout="flex"
      flexDirection="column"
      width={["100%", null, "700px"]}
      bg={ColorPreset.BackgroundLight_01}
      gutterH={[2, 4]}
      gutterV={gutterV}
      borderRadius={1.5}
      borderColor={ColorPreset.BorderOnLight_04}
      borderWidth={1}
    >
      {banner}

      <Box
        width="100%"
        layout="flex"
        flexDirection="column"
        justifyContent={JustifyContent.Center}
        alignItems={AlignItems.Center}
        spaceBelow={1.5}
      >
        {image}
      </Box>
      <Space v={1.5} />
      <ReadingOptimized alignText={AlignItems.FlexStart}>
        <H2 preset={TypePreset.Heading_06}>{title}</H2>
        <Space v={1.5} />
        <Box>
          <P preset={TypePreset.Body_01}>{description}</P>
        </Box>
        <Space v={2} />
        <Box
          width="100%"
          layout="flex"
          flexDirection={["column", "row"]}
          justifyContent={JustifyContent.FlexStart}
          alignItems={[null, AlignItems.Center]}
        >
          {buttons}
        </Box>
      </ReadingOptimized>
    </Box>
  </Box>
);
